export default "__VITE_ASSET__FeWkBi0p__ 400w, __VITE_ASSET__DJ2sUKfj__ 800w, __VITE_ASSET__Cx9y62$r__ 1200w";